import { Component, OnInit } from '@angular/core';
import { CustomTest, TestGroup } from 'src/app/models/custom_test_model';
import { CustomTestService } from 'src/app/services/custom-test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

interface GroupWithQty extends TestGroup {
  qty: number
}

@Component({
  selector: 'app-custom-tests',
  templateUrl: './custom-tests.component.html',
  styleUrls: ['./custom-tests.component.css']
})
export class CustomTestsComponent implements OnInit {

  public tests: CustomTest[] = []
  public groups: TestGroup[] = []
  public groupsWithQty: GroupWithQty[] = []
  public groupFilter: string = ''
  public user;

  constructor(
    private customTestService: CustomTestService,
    private userService: UserService
  ) { }

  async ngOnInit() {

    this.user = await this.userService.getUser().toPromise()

    this.customTestService.getCustomTests({}).subscribe(
      async (response: CustomTest[]) => {
        this.tests = response
        this.groups = await this.customTestService.getTestGroups({}).toPromise()
        if (this.user.role != 'admin'){
          this.groups = this.groups.filter(group => group.active || group.userId === this.user._id)
          this.tests = this.tests.filter(test => test.active || test.userId === this.user._id)
        }else{
          this.tests = this.tests.filter(test => !test.userId)
        }
        this.groupsWithQty = this.groups.map(group => {
          return {
            ...group,
            qty: this.tests.filter(test => test.groupId === group._id).length
          }
        })
        this.groupsWithQty.push({
          _id: '',
          active: false,
          title: 'Sin grupo',
          description: 'Pruebas sin grupo',
          info: {},
          userId: '',
          qty: this.tests.filter(test => (!test.groupId && this.user.role == 'admin') || (!test.groupId && test.userId == this.user._id)).length
        })
        this.groupFilter = this.groups[0]._id
        this.tests.forEach(test => {
          test.groupName = this.groups.find(group => group._id === test.groupId)?.title || 'Sin grupo'
        })
      },
      error => {
        console.log(error)
      }
    )
  }

  async handleDelete(id: string){
    let response = await Swal.fire({
      title: '¿Estás seguro de que deseas eliminar esta prueba?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    })

    if (!response.isConfirmed) return

    this.customTestService.deleteCustomTest(id).subscribe(
      response => {
        Swal.fire({
          text: 'La prueba ha sido eliminada exitosamente',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        })
        this.tests = this.tests.filter(test => test._id !== id)
      },
      error => {
        console.log(error)
      }
    )
  }

  toggleVisibility(test: CustomTest){
    this.customTestService.updateCustomTest({active: !test.active}, test._id).subscribe(
      response => {
        test.active = !test.active
      },
      error => {
        console.log(error)
      }
    )
  }

}
